import { elakay_API } from "../../config";
import { uploadFileRequest } from "../../utils/uploadRequest";

const authHeaders = (token) => ({
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
});

const handleResponse = (response) => response.json();
const handleError = (err) => ({
    success: false,
    error: err.message || "Une erreur inconnue est survenue"
});

export const listChatbotIntents = (token, { language, category, enabled } = {}) => {
    const params = new URLSearchParams();
    if (language) params.set("language", language);
    if (category) params.set("category", category);
    if (enabled !== undefined) params.set("enabled", String(enabled));
    const query = params.toString() ? `?${params.toString()}` : "";

    return fetch(`${elakay_API}/chatbot/intents${query}`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(handleResponse)
        .catch(handleError);
};

export const createChatbotIntent = (token, intent) => {
    return fetch(`${elakay_API}/chatbot/intents`, {
        method: "POST",
        headers: authHeaders(token),
        body: JSON.stringify(intent)
    })
        .then(handleResponse)
        .catch(handleError);
};

export const updateChatbotIntent = (token, intentDbId, intent) => {
    return fetch(`${elakay_API}/chatbot/intents/${intentDbId}`, {
        method: "PUT",
        headers: authHeaders(token),
        body: JSON.stringify(intent)
    })
        .then(handleResponse)
        .catch(handleError);
};

export const deleteChatbotIntent = (token, intentDbId) => {
    return fetch(`${elakay_API}/chatbot/intents/${intentDbId}`, {
        method: "DELETE",
        headers: authHeaders(token)
    })
        .then(handleResponse)
        .catch(handleError);
};

export const bulkImportChatbotIntents = (token, payload) => {
    return fetch(`${elakay_API}/chatbot/intents/bulk-import`, {
        method: "POST",
        headers: authHeaders(token),
        body: JSON.stringify(payload)
    })
        .then(handleResponse)
        .catch(handleError);
};

// Télémétrie : signale qu'un vrai client a reçu une réponse de cet intent
// dans userMessage. Non bloquant pour l'UX : les appelants ignorent
// généralement le résultat (fire-and-forget).
export const trackChatbotIntentUsage = (token, intentDbId) => {
    return fetch(`${elakay_API}/chatbot/intents/${intentDbId}/track-use`, {
        method: "POST",
        headers: authHeaders(token)
    })
        .then(handleResponse)
        .catch(handleError);
};

// Patch ciblé façon AnimationSettings (updateSetting) : { language,
// intentId?, path, value }. Modifie un seul champ (objet, array, ou valeur
// simple) sans toucher au reste du document.
export const patchChatbotIntentField = (token, payload) => {
    return fetch(`${elakay_API}/chatbot/intents/patch`, {
        method: "PATCH",
        headers: authHeaders(token),
        body: JSON.stringify(payload)
    })
        .then(handleResponse)
        .catch(handleError);
};

// Variante en masse : { updates: [{ language, intentId?, path, value }, ...] }.
export const patchChatbotIntentFieldsBulk = (token, payload) => {
    return fetch(`${elakay_API}/chatbot/intents/patch/bulk`, {
        method: "PATCH",
        headers: authHeaders(token),
        body: JSON.stringify(payload)
    })
        .then(handleResponse)
        .catch(handleError);
};

// Upload d'une image ou vidéo pour un intent (stocké côté serveur dans
// data/images ou data/videos selon le type). Renvoie { url, path, filename,
// originalName, size, type } à ajouter ensuite au champ images/videos de
// l'intent via createChatbotIntent/updateChatbotIntent.
export const uploadChatbotMedia = (file, token) => uploadFileRequest({
    url: `${elakay_API}/chatbot/media/upload`,
    feature: "chatbotMedia",
    file,
    headers: { Authorization: `Bearer ${token}` },
});
